
export default function BlogGrid() {
  const blogPosts = [
    {
      title: "Building Confidence in Young Soccer Players",
      excerpt: "Discover proven strategies to help young athletes develop self-confidence and overcome performance anxiety on the field.",
      category: "Mental Game",
      author: "Coach Sarah Johnson",
      date: "March 12, 2024",
      readTime: "5 min read",
      image: "https://public.readdy.ai/ai/img_res/e124818438ff1b18eb188afdf4048015.jpg"
    },
    {
      title: "Nutrition Guide for Youth Soccer Athletes",
      excerpt: "Learn what to eat before, during, and after games to maximize performance and support healthy growth and development.",
      category: "Nutrition",
      author: "Dr. Emily Chen",
      date: "March 10, 2024",
      readTime: "7 min read",
      image: "https://readdy.ai/api/search-image?query=Healthy%20sports%20nutrition%20meal%20with%20fruits%20vegetables%20and%20protein%20for%20young%20athletes%2C%20colorful%20balanced%20diet%20plate%20with%20soccer%20ball%20nearby%2C%20clean%20kitchen%20setting%20with%20natural%20lighting&width=400&height=250&seq=blog-2&orientation=landscape"
    },
    {
      title: "The Importance of Proper Warm-Up Routines",
      excerpt: "Prevent injuries and improve performance with these essential warm-up exercises designed specifically for soccer players.",
      category: "Training Tips",
      author: "Coach Mike Rodriguez",
      date: "March 8, 2024",
      readTime: "4 min read",
      image: "https://readdy.ai/api/search-image?query=Soccer%20team%20doing%20warm-up%20stretching%20exercises%20on%20grass%20field%2C%20players%20in%20colorful%20training%20gear%20following%20coach%20instructions%2C%20professional%20sports%20training%20atmosphere&width=400&height=250&seq=blog-3&orientation=landscape"
    },
    {
      title: "Choosing the Right Soccer Cleats for Your Child",
      excerpt: "A comprehensive guide to selecting the perfect cleats based on playing surface, position, and foot type.",
      category: "Equipment",
      author: "Coach Lisa Thompson",
      date: "March 5, 2024",
      readTime: "6 min read",
      image: "https://readdy.ai/api/search-image?query=Various%20types%20of%20soccer%20cleats%20and%20boots%20displayed%20on%20grass%20field%2C%20different%20styles%20and%20colors%20for%20youth%20players%2C%20professional%20sports%20equipment%20photography%20with%20clean%20background&width=400&height=250&seq=blog-4&orientation=landscape"
    },
    {
      title: "Developing First Touch Skills at Home",
      excerpt: "Simple exercises parents and players can do at home to improve ball control and first touch technique.",
      category: "Training Tips",
      author: "Coach Martinez",
      date: "March 3, 2024",
      readTime: "5 min read",
      image: "https://readdy.ai/api/search-image?query=Young%20soccer%20player%20practicing%20ball%20control%20in%20backyard%20with%20parent%20watching%2C%20home%20training%20setup%20with%20cones%20and%20soccer%20ball%2C%20family%20bonding%20through%20sports&width=400&height=250&seq=blog-5&orientation=landscape"
    },
    {
      title: "Understanding Player Development Stages",
      excerpt: "Learn about the different stages of youth soccer development and what to expect at each age group.",
      category: "Youth Development",
      author: "Coach Jennifer Adams",
      date: "March 1, 2024",
      readTime: "8 min read",
      image: "https://readdy.ai/api/search-image?query=Different%20age%20groups%20of%20young%20soccer%20players%20training%20together%20on%20field%2C%20showing%20progression%20from%20small%20children%20to%20teenagers%2C%20diverse%20group%20in%20soccer%20academy%20uniforms&width=400&height=250&seq=blog-6&orientation=landscape"
    },
    {
      title: "Hydration Strategies for Young Athletes",
      excerpt: "Keep your young soccer player properly hydrated with these expert tips for before, during, and after training.",
      category: "Nutrition",
      author: "Dr. Emily Chen",
      date: "February 28, 2024",
      readTime: "4 min read",
      image: "https://readdy.ai/api/search-image?query=Young%20soccer%20player%20drinking%20water%20from%20sports%20bottle%20during%20break%2C%20hydration%20and%20health%20focus%2C%20sunny%20outdoor%20training%20field%20with%20coach%20and%20teammates%20nearby&width=400&height=250&seq=blog-7&orientation=landscape"
    },
    {
      title: "Building Team Chemistry and Communication",
      excerpt: "Discover how to help young players develop better communication skills and team chemistry on the field.",
      category: "Youth Development",
      author: "Coach Mike Rodriguez",
      date: "February 25, 2024",
      readTime: "6 min read",
      image: "https://readdy.ai/api/search-image?query=Young%20soccer%20team%20in%20huddle%20discussing%20strategy%20with%20coach%2C%20teamwork%20and%20communication%20in%20youth%20sports%2C%20positive%20coaching%20environment%20on%20grass%20field&width=400&height=250&seq=blog-8&orientation=landscape"
    },
    {
      title: "Recovery and Rest for Young Soccer Players",
      excerpt: "Learn why rest and recovery are crucial for young athletes and how to implement proper recovery strategies.",
      category: "Training Tips",
      author: "Coach Sarah Johnson",
      date: "February 22, 2024",
      readTime: "5 min read",
      image: "https://readdy.ai/api/search-image?query=Young%20soccer%20player%20stretching%20and%20cooling%20down%20after%20training%20session%2C%20recovery%20and%20wellness%20focus%2C%20peaceful%20outdoor%20setting%20with%20sports%20equipment%20nearby&width=400&height=250&seq=blog-9&orientation=landscape"
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Latest Articles</h2>
          <p className="text-xl text-gray-600">Stay updated with the latest tips, insights, and news from our coaching experts</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    post.category === 'Training Tips' ? 'bg-green-100 text-green-800' :
                    post.category === 'Youth Development' ? 'bg-blue-100 text-blue-800' :
                    post.category === 'Nutrition' ? 'bg-orange-100 text-orange-800' :
                    post.category === 'Mental Game' ? 'bg-purple-100 text-purple-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {post.category}
                  </span>
                  <span className="text-gray-500 text-sm">{post.readTime}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">{post.title}</h3>
                <p className="text-gray-600 mb-4 line-clamp-3">{post.excerpt}</p>
                
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <span>{post.author}</span>
                  <span>{post.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Load More Articles
          </button>
        </div>

        {/* Newsletter Signup */}
        <div className="mt-16 bg-purple-50 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Stay Updated</h3>
          <p className="text-gray-600 mb-6">Subscribe to our newsletter for the latest soccer tips, training advice, and academy news.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
            />
            <button className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
